export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_orderCust') ||'订单所属客户',
    field: 'orderCustCode',
    align: 'center',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/customerSelect',
        filterable: true,
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_orderByDepCode') || '订单所属业务部门',
    field: 'orgDepFullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'orderByDepCode' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
